import { Icon, ICONS } from 'components/Icon';
import * as React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Image } from 'expo-image';
import { Pressable } from './Pressable';
import { Svg } from './Svg/Svg';
import { CloudThumbnail } from './Thumbnail/CloudThumbnail';

type AvatarProps = {
  data:
    | /** Use Icon */
    null
    | {
        /** SVG data - uses Svg component */
        svgData: string;
        localUrl?: never;
        remoteUrl?: never;
      }
    | {
        /** Local URL or base 64 data - Uses Image component */
        localUrl: string;
        svgData?: never;
        remoteUrl?: never;
      }
    | {
        /** Local URL - Uses CloudThumbnail component */
        remoteUrl: string;
        localUrl?: never;
        svgData?: never;
      };

  onPress?: () => void;
  size?: number;
  style?: StyleProp<ViewStyle>;
  imagePadding?: number;
  iconPadding?: number;
  svgPadding?: number;
  imageBackgroundColor?: string;
  iconColor?: string;
  icon?: ICONS;
  resizeMode?: 'cover' | 'contain';
};

const SIZE = 36;

export const Avatar: React.FC<AvatarProps> = ({
  data,
  onPress,
  icon = ICONS.ImageThin,
  size = SIZE,
  style,
  imageBackgroundColor,
  imagePadding = 0,
  iconPadding,
  svgPadding = 0,
  iconColor,
  resizeMode = 'cover',
}) => {
  const imageSize = size - imagePadding * 2;
  const svgSize = size - svgPadding * 2;
  const iconSize =
    iconPadding === undefined ? size - size / 2.5 : size - iconPadding * 2;
  return (
    <Pressable
      onPress={onPress}
      style={[
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: imageBackgroundColor || '#dddddd',
          overflow: 'hidden',
          alignItems: 'center',
          justifyContent: 'center',
        },
        style,
      ]}
    >
      {data?.localUrl ? (
        <Image
          source={{ uri: data.localUrl }}
          contentFit={resizeMode}
          style={{
            height: imageSize,
            width: imageSize,
            margin: imagePadding,
          }}
        />
      ) : data?.svgData ? (
        <Svg
          data={data.svgData}
          width={svgSize}
          height={svgSize}
          style={{ margin: svgPadding, resizeMode }}
        />
      ) : data?.remoteUrl ? (
        <CloudThumbnail
          icon={icon}
          iconSize={iconSize}
          contentFit={resizeMode}
          imageUrl={data.remoteUrl}
          width={imageSize}
          height={imageSize}
          iconColor={iconColor || '#ffffff'}
          style={{
            backgroundColor: imageBackgroundColor,
            padding: imagePadding,
          }}
        />
      ) : (
        <Icon source={icon} size={iconSize} color={iconColor || '#bbbbbb'} />
      )}
    </Pressable>
  );
};
